import { createRouter, createWebHistory } from 'vue-router'
import { createAuthGuard } from '@auth0/auth0-vue'
import BrandMasterDataPage from '@/pages/BrandMasterDataPage.vue'
import LineMasterDataPage from '@/pages/LineMasterDataPage.vue'
import ProductMasterDataPage from '@/pages/ProductMasterDataPage.vue'
import CategoryMasterDataPage from '@/pages/CategoryMasterDataPage.vue'
import BenefitMultiPackMasterDataPage from '@/pages/BenefitMultiPackMasterDataPage.vue'

import HomePage from '@/pages/HomePage.vue'

const authGuard = createAuthGuard()

// NOTE: With authGuard, user is immediately redirected to Auth0 Universal Login page if not logged in.
// NOTE: routes requiring admin role will need:
// requiresAdmin: true
const router = new createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Participants',
      meta: {
        title: 'Participants',
        // requiresAdmin: true // TODO: Uncomment once user page flow is decided.
      },
      component: HomePage,
      beforeEnter: authGuard
    },
    {
      path: '/product-matching',
      name: 'Product Matching',
      meta: {
        title: 'Product Matching',
        requiresAdmin: true
      },
      component: () => import('./pages/ProductMatchingPage.vue'),
      beforeEnter: authGuard
    },
    {
      path: '/brand-master-data',
      name: 'Brand Master Data',
      component: BrandMasterDataPage,
      meta: {
        title: 'Master Brands'
      },
      beforeEnter: authGuard
    },
    {
      path: '/line-master-data',
      name: 'Line Master Data',
      component: LineMasterDataPage,
      meta: {
        title: 'Master Lines'
      },
      beforeEnter: authGuard
    },
    {
      path: '/benefit-multipack-master-data',
      name: 'Benefit / Multi-Pack Master Data',
      component: BenefitMultiPackMasterDataPage,
      meta: {
        title: 'Benefit / Multi-Pack'
      },
      beforeEnter: authGuard
    },
    {
      path: '/category-master-data',
      name: 'Category Master Data',
      component: CategoryMasterDataPage,
      meta: {
        title: 'Master Categories'
      },
      beforeEnter: authGuard
    },
    {
      path: '/product-master-data',
      name: 'Product Master Data',
      component: ProductMasterDataPage,
      meta: {
        title: 'Master Products'
      },
      beforeEnter: authGuard
    },
    {
      path: '/admin-mutation-logs',
      name: 'Admin Mutation Logs',
      component: () => import('./pages/AdminMutationLogsPage.vue'),
      meta: {
        title: 'Mutation Logs'
      },
      beforeEnter: authGuard
    },
    {
      path: '/history',
      name: 'History',
      component: () => import('./pages/HistoryPage.vue'),
      meta: {
        title: 'History'
      },
      beforeEnter: authGuard
    },
    {
      path: '/:pathMatch(.*)',
      redirect: () => {
          return '/'
      }
    }
  ]
})


export default router
